
import FormControl from "@mui/material/FormControl";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import Button from "@mui/material/Button";
import RadioGroup from "@mui/material/RadioGroup";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4
};

const DeleteAppModal = (props) => {

    const {openDelete,setOpenDelete,handleDeleteChange,handleDeleteSubmit,selectedValue} = props

    return (
        <Modal open={openDelete} onClose={() => setOpenDelete(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h4" component="h2">
                    App Status
                </Typography>
                <br></br>
                <Typography id="modal-modal-title" variant="h4" component="h2">
                    <FormControl fullWidth>
                        <RadioGroup value={selectedValue} onChange={handleDeleteChange}>
                            <FormControlLabel value="option2" control={<Radio />} label="Disable" />
                            <FormControlLabel value="option3" control={<Radio />} label="Enable" />
                        </RadioGroup>
                    </FormControl>
                </Typography>

                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <Button type="submit" variant="contained" color="primary" onClick={handleDeleteSubmit}>
                        Submit
                    </Button>
                </Typography>
            </Box>
        </Modal>
    )
}

export default DeleteAppModal;

